import { createFileRoute } from "@tanstack/react-router";

import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/office/orders/create")({
  component: () => (
    <MaskRedirect
      to="/office/orders/active"
      action="create-order"
      mask="/office/orders/create"
    />
  ),
});
